import * as Yup from 'yup'

export const especialidadeSchema = Yup.object({
  nome: Yup.string().required('O nome é obrigatório'),
  tiposAtendimento: Yup.array()
    .of(Yup.object())
    .min(1, 'Selecione ao menos um tipo de atendimento'),
  conselho: Yup.object().nullable().notRequired(),
})
